enum CrossSellButtonClass {
  AB_GREEN = 'ab-green',
  GS_BLUE = 'gs-blue',
  VB_RED = 'vb-red',
}

export default CrossSellButtonClass;
